import { Component, OnInit } from '@angular/core';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import dayjs from 'dayjs';
import { Dashboard, DashboardComponentSize, DEFAULT_DASHBOARD_CONFIG } from '@models/dashboard';
import { DashboardService } from '@services/dashboard.service';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { DashboardComponent } from '../dashboard.component';

_('dashboard.title');

@Component({
  selector: 'app-dashboard',
  templateUrl: './edit-dashboard.component.html',
  styleUrls: ['./edit-dashboard.component.scss'],
})
export class EditDashboardComponent implements OnInit {
  date = dayjs();

  isLoading = true;

  error?: HttpErrorResponse;

  dashboard!: Dashboard;

  componentRegistry = DashboardComponent.componentRegistry;

  widgetTypes = Object.keys(this.componentRegistry).map((key) => key);

  newWidget: string | undefined = undefined;

  sizeOptions = Object.entries(DashboardComponentSize).map(([key, value]) => ({
    key,
    value: value as DashboardComponentSize,
  }));

  constructor(private dashboardService: DashboardService, private translate: TranslateService) {}

  ngOnInit() {
    this.dashboardService.getDashboard().subscribe({
      next: (dashboard) => {
        this.dashboard = dashboard || { configuration: DEFAULT_DASHBOARD_CONFIG };
        this.isLoading = false;
      },
      error: (err: HttpErrorResponse) => {
        this.error = err;
        this.isLoading = false;
      },
    });
  }

  saveDashboard() {
    if (this.dashboard) {
      this.error = undefined;
      this.isLoading = true;
      this.dashboardService.saveDashboard(this.dashboard).subscribe({
        next: () => {
          this.isLoading = false;
        },
        error: (err: HttpErrorResponse) => {
          this.error = err;
          this.isLoading = false;
        },
      });
    }
  }

  addWidget() {
    const newWidget = {
      component: this.newWidget!,
      size: DashboardComponentSize.HALF,
      configuration: {
        title: this.translate.instant('dashboard.edit.newWidget'),
        description: '',
      },
    };
    this.dashboard.configuration.items.push(newWidget);
  }

  moveWidgetUp(index: number) {
    if (this.dashboard && index > 0) {
      const temp = this.dashboard.configuration.items[index - 1];
      this.dashboard.configuration.items[index - 1] = this.dashboard.configuration.items[index];
      this.dashboard.configuration.items[index] = temp;
    }
  }

  moveWidgetDown(index: number) {
    if (this.dashboard && index < this.dashboard.configuration.items.length - 1) {
      const temp = this.dashboard.configuration.items[index + 1];
      this.dashboard.configuration.items[index + 1] = this.dashboard.configuration.items[index];
      this.dashboard.configuration.items[index] = temp;
    }
  }

  removeWidget(index: number) {
    if (this.dashboard && index >= 0 && index < this.dashboard.configuration.items.length) {
      this.dashboard.configuration.items.splice(index, 1);
    }
  }
}
